const PAYMENT_METHOD_DOWNTIME_HALF_CARD = "pmd_half_card";

export const PAYMENT_METHOD_DOWNTIME_HALF_CARD_TEST_IDS = {
    CONTAINER: `${PAYMENT_METHOD_DOWNTIME_HALF_CARD}_container`,
};
